import React from 'react'

import { ResponsiveContainer, Legend, LabelList, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { Col } from 'antd'

export const renderEibActionsGraph = (data, category, label, datakey) => {
  return (
    <Col span={24} style={{ textAlign: 'left', alignItems: 'left' }}>
      <h3 style={{ fontSize: 14, fontWeight: 400, color: '#8591A1' }}>{label}</h3>
      <ResponsiveContainer width="99%" aspect={1.6}>
        <BarChart barSize={20} layout="vertical" data={data}>
          <CartesianGrid stroke="#ccc" horizontal={false} />
          <Tooltip />
          <XAxis type="number" tickCount={22} domain={['auto', 'auto']} allowDecimals={false} />
          <YAxis dataKey={datakey} width={100} tickLine={false} type="category" />
          {category.map((item, index) =>
            index === category.length - 1 ? (
              <Bar key={item.key} name={item.name} dataKey={item.key} fill={item.color} stackId="stack">
                <LabelList dataKey="total" position="right" />
              </Bar>
            ) : (
              <Bar key={item.key} name={item.name} dataKey={item.key} fill={item.color} stackId="stack" />
            )
          )}
          <Legend layout="horizontal" align="left" verticalAlign="bottom" iconType="rect" iconSize={20} />
        </BarChart>
      </ResponsiveContainer>
    </Col>
  )
}
